import { string, bool } from "prop-types";
import cx from "classnames";

const propTypes = {
  iconName: string,
  className: string,
  countryCode: string,
};

const Icon = (props) => {
  const { iconName, className, countryCode, ...otherProps } = props;

  const iconClass = iconName || `country-${countryCode}`;

  return (
    <svg
      className={cx("icon", `icon--${iconClass}`, className)}
      {...otherProps}
    >
      {countryCode && (
        <use
          xlinkHref={`/Areas/EGH/assets/img/map-sprite.svg#${countryCode}`}
        ></use>
      )}
      {iconName && (
        <use
          xlinkHref={`/Areas/EGH/assets/img/svg-sprite.svg#${iconName}`}
        ></use>
      )}
    </svg>
  );
};

Icon.propTypes = propTypes;
export default Icon;
